/**
 *@author: Sirisha.M
 *@Description : This component is mainly for creating Analysis and Corrective Actions
 **/
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Button,
  Input,
  Tabs,
  Form,
  Select,
  message,
  Modal,
  Tooltip,
  Row,
  Col,
  DatePicker,
  Upload,
  Collapse,
  Drawer,
  Popconfirm
} from 'antd';
import HierarchyModal from './HierarchyModal';
import StyledTable from '../../../commons/styles/table';

import {
  getHierarchyTreeData,
  getAllAnalysisById,
  // DeleteAttachment,
  onReportManagerAction,
  getDeviceList,
  getUserHeirarchyData,
  getAnalysisList,
  getDepartmentList,
  getSeverityList,
  getFailureList,
  getUserList,
  getStatusList,
  getFailureCodeList,
  createFailure,
  updateFailure,
  createCorrectiveActionsMultiple,
  updateCorrectiveActionsMultiple,
  DeleteAttachment,
  getQuestionsList,
  getUsersList,
  getAnalysisByIdMultiple,
  getCorrectiveByIdMultiple
} from './ChartCalls';
import dayjs from 'dayjs';
// import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import Highlighter from 'react-highlight-words';
// import { StyledTable } from './style';

import {
  SearchOutlined,
  UpSquareOutlined,
  UpOutlined,
  DownOutlined,
  CloudUploadOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  RollbackOutlined,
  UploadOutlined
} from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import themeSettings from '../../../commons/styles/themeSettings.json';

// import { translation } from '../../commons/translation';
import '../style.css';
import { API_FRACAS, API_FRACAS_MULTIPLE, IPAddress } from '../../../commons/api';
// import { QuestionCircleOutlined } from '@ant-design/icons';
const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;

const AnalysisAndCorrectiveActions = (props) => {
  const [presentActiveKey, setPresentActiveKey] = useState(props.presentActiveKey || 'List');

  const [formObject, setFormObject] = useState({});
  const [analysisFormObject, setAnalysisFormObject] = useState({});
  const [correctiveFormObject, setCorrectiveFormObject] = useState({
    CorrectiveActionsAttachments: {
      0: [], // attachments for corrective index 0
      1: [], // attachments for corrective index 1
      // ...
    }
  });

  const [searchedColumn, setSearchedColumn] = useState('');
  const [devicesList, setDevicesList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [checkedValue, setCheckedValue] = useState(props.checkedValue || null);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [questionsList, setQuestionsList] = useState([]);
  const [Questions, setQuestions] = useState([]);
  const [Corrective, setCorrective] = useState([]);
  const [AnalysisValues, setAnalysisValues] = useState([]);
  const [ExistingCorrective, setExistingCorrective] = useState([]);
  const [dataSourceForAnalysis, setDataSourceForAnalysis] = useState([]);
  const [FailureTypeList, setFailureTypeList] = useState([]);
  const [FailureCodeList, setFailureCodeList] = useState([]);
  const [Users, setUsers] = useState([]);
  const [SeverityList, setSeverityList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [failureTypeId, setFailureTypeId] = useState(null);
  const [showusecasedownloadModal, setShowusecasedownloadModal] = useState(false);
  const [analysisShowusecasedownloadModal, setAnalysisShowusecasedownloadModal] = useState(false);
  const [analysisShowusecasedownloadModalExisting, setAnalysisShowusecasedownloadModalExisting] = useState(false);

  const [correctiveShowusecasedownloadModal, setCorrectiveShowusecasedownloadModal] = useState(false);
  const [correctiveShowusecasedownloadModalExisting, setCorrectiveShowusecasedownloadModalExisting] = useState(false);

  // const [checked, setChecked] = useState(false);
  const [selectedKey, setSelectedKey] = useState('');
  const [statusList, setStatusList] = useState([]);
  const [status, setStatus] = useState(null);
  const [correctiveStatus, setCorrectiveStatus] = useState(null);
  const [correctiveButton, setCorrectiveButton] = useState(false);
  const [failureText, setFailureText] = useState('');
  const [current, setCurrent] = useState(props.current);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedIndexAnalysis, setSelectedIndexAnalysis] = useState(null);
  const [selectedIndexEC, setSelectedIndexEC] = useState(null);
  const [selectedStatusId, setSelectedStatusId] = useState(null);


  const h2Ref = useRef(null);
  const h3Ref = useRef(null);
  const CARef = useRef(null);

  const [form1] = Form.useForm();
  const [form3] = Form.useForm();
  const [form2] = Form.useForm();
  const [form4] = Form.useForm();


  const [QuestionRef] = Form.useForm();
  const [DepartmentRef] = Form.useForm();
  const [DepartmentRef1] = Form.useForm();
  const [AnalysisRef] = Form.useForm();
  const [ExistingCorrectiveRef] = Form.useForm();


  const myRef = useRef(null);
  const myRef1 = useRef(null);
  const myRef2 = useRef(null);

  // const QuestionRef = useRef(null);

  const failureInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let devicesList = await getDeviceList();
      setDevicesList(devicesList);

      let data2 = await getAnalysisList(props.screenName);
      setDataSourceForAnalysis(data2);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (current !== props.current) {
      setCurrent(props.current);
    }
  }, [current, props.current]);
  useEffect(() => {

    if (presentActiveKey !== props.presentActiveKey) {
      setPresentActiveKey(props.presentActiveKey);
    }
  }, [presentActiveKey, props.presentActiveKey]);
  useEffect(() => {

    if (checkedValue !== props.checkedValue) {
      setCheckedValue(props.checkedValue);
    }
  }, [checkedValue, props.checkedValue]);

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const onAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };

  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };
  const onStatusChange = (value) => {
    let selectedStatus = statusList && statusList.filter(item => item.NextStatus === value);
    setSelectedStatusId(selectedStatus && selectedStatus[0] && selectedStatus[0].Id);

    setStatus(value);
    if (value === 'Analysis Completed') {
      setCorrectiveButton(true);
    } else {
      setCorrectiveButton(false);
    }
  };
  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current && myRef.current.click();
    } else {
      setShowusecasedownloadModal(true);
    }
  };
  const fileUpload = (info) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (formObject) {
        if (formObject['Attachments']) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];

          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject['Attachments'] = [];
          formObject['Attachments'].push({ Id: id, file: Name });
        }
      } else {
        if (formObject && formObject['Attachments'] && formObject['Attachments'].length !== 0) {
          formObject['Attachments'] =
            formObject && formObject['Attachments'] ? formObject['Attachments'] : [];
          formObject['Attachments'].push({ Id: id, file: Name });
        } else {
          formObject &&
            formObject['Attachments'] &&
            formObject['Attachments'].push({ Id: id, file: Name });
        }
      }

      setFormObject(formObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const beforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        filename: file.name
      });
    };
  };
  const ResetFields = async () => {
    form1?.resetFields();
    form1?.setFieldsValue({
      ReportedDate: dayjs(),
      ReportedBy: props?.userProfile?.user?.FirstName,
      Status: "Open",
      // ...other defaults
    });

    let formData = {
      Device: null,
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: "Open",
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef?.setFieldsValue({
      Users: []
    });
    form4?.setFieldsValue({
      Corrective: []
    });
    setUsers([]);
    setQuestions([]);
    setFormObject(formData);
    setSelectedDevice(null);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);
    setFailureCodeList([]);
    setUsersList([]);
    setStatus("Open");
  };
  const onCancel = () => {
    ResetFields();
    // analysisFormResetFields();
    // correctiveResetFields();
    setCorrectiveStatus(null);
    setCorrectiveButton(false);
    props.onActiveTabChange('List');
    // setPresentActiveKey('List');
    setCheckedValue(null);
  };
  const DeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = formObject && formObject.Attachments && formObject.Attachments.filter(item => item.Id !== record.Id);
    let data = {
      ...formObject,
      Attachments: filteredAttachments
    };
    setFormObject(data);
  };
  const onAnalysisFinishFailed = () => {
    message.error("Please add mandatory fields");
  };
  const existingAnalysisHandleClick = (e, index) => {
    const rowKey = Array.isArray(index) ? index.join('-') : index;

    setSelectedIndexAnalysis(rowKey);
    if (e === 'Add New Attachments') {
      myRef1.current && myRef1.current.click();
    } else {
      setAnalysisShowusecasedownloadModalExisting(true);
    }
  };

  const onModalCancel = () => {
    if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
      setCheckedValue(selectedDevice);
    } else {
      setCheckedValue(null);
    }

    setTreeVisible(false);
  };
  const hierarchyDropdownChange = async (value) => {
    setCheckedValue(value);
    let FailureCodeList = await getFailureCodeList(value);
    setFailureCodeList(FailureCodeList);
    setSelectedDevice(value);
    setFailureTypeId(null);
    setQuestionsList([]);
    setTreeVisible(false);
    form1?.setFieldsValue({
      Device: value,
      FailureTypeId: null,
      FaultCode: null
    });
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef?.setFieldsValue({
      Users: []
    });
    setUsers([]);
    setQuestions([]);
  };
  const onCorrectiveActionClick = async () => {
    setCorrectiveStatus('Analysis Completed');
    setCorrectiveButton(false);
    let payload = {
      ReportId: formObject && formObject.ReportId,
      Status: status
    };

    let response = await onReportManagerAction(payload);
    if (response && response.status && response.status === 200) {
      const editedRow = await getAnalysisByIdMultiple(formObject.ReportId, 'Analysis and Corrective Actions');
      const analysisList = await getAnalysisList(props.screenName);
      setDataSourceForAnalysis(analysisList);
      let StatusList = await getStatusList(editedRow.FracasStatus);
      setStatusList(StatusList);
      //     let selectedStatusId = StatusList && StatusList.filter(item=>item.NextStatus === editedRow.FracasStatus);
      // setSelectedStatusId(selectedStatusId);
    }
  };
  const correctiveFileUpload = (info, key, index) => {
    const rowKey = Array.isArray(index) ? index.join('-') : index;
    if (info.file.status === 'done') {
      let id = info?.file?.response?.Id;
      let Name = info?.file?.response?.Name;

      setCorrectiveFormObject((prev) => {
        const attachments = prev && prev.CorrectiveActionsAttachments || {};
        const currentAttachments = attachments[rowKey] || [];

        return {
          ...prev,
          CorrectiveActionsAttachments: {
            ...attachments,
            [rowKey]: [...currentAttachments, { Id: id, file: Name }]
          }
        };
      });

      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const analysisResetFields = () => {
    form2?.setFieldsValue({
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      OccuranceCount: null,
      Remarks: null,
      ReportedDate: dayjs(),
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      UserId: null,
      DepartmentId: null
    });
    let formData = {
      Type: null,
      Equipment: null,
      FailureTypeId: null,
      FaultCode: null,
      FailureDescription: null,
      SeverityId: null,
      Impact: null,
      OccuranceDate: null,
      ReportedDate: dayjs(),
      OccuranceCount: null,
      Remarks: null,
      // Attachments: [],
      ReportedBy:
        props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
      Comments: null,
      Status: null,
      DepartmentId: null,
      UserId: null
    };
    QuestionRef?.setFieldsValue({
      Questions: []
    });
    DepartmentRef1?.setFieldsValue({
      Users: []
    });
    form4?.setFieldsValue({
      Corrective: []
    });
    ExistingCorrectiveRef?.setFieldsValue({
      ExistingCorrective: []
    });
    AnalysisRef?.setFieldsValue({
      AnalysisValues: []
    });
    // setUsers([]);
    setExistingCorrective([]);
    setAnalysisValues([]);
    setQuestions([]);
    setFormObject(formData);
    setSelectedDevice(null);
  };
  const correctiveResetFields = () => {
    form4?.setFieldsValue({
      Corrective: []
    });
    ExistingCorrectiveRef?.setFieldsValue({
      ExistingCorrective: []
    });
    setCorrective([]);
    setExistingCorrective([]);
    // form4?.setFieldsValue({
    //   ChangeRecommendations: null,
    //   CorrectiveActionType: null,
    //   CorrectiveActionsAttachments: [],
    //   ImplementedCorrectiveActions: null,
    //   PlannedCorrectiveActions: null,
    //   VerificationAndValidationFieldRemarks: null
    // });
    // let formData = {
    //   // ...formObject,
    //   ChangeRecommendations: null,
    //   CorrectiveActionType: null,
    //   CorrectiveActionsAttachments: [],
    //   ImplementedCorrectiveActions: null,
    //   PlannedCorrectiveActions: null,
    //   VerificationAndValidationFieldRemarks: null,

    // };
    setCorrectiveFormObject({});
    setCorrectiveButton(false);
    setCorrectiveStatus(null);
  };
  const onAnalysisAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = analysisFormObject && analysisFormObject.AnalysisAttachments && analysisFormObject.AnalysisAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...analysisFormObject,
      AnalysisAttachments: filteredAttachments
    };
    setAnalysisFormObject(data);
  };
  const onCorrectiveAttachmentDelete = async (e, record) => {
    // let response = await DeleteAttachment(record.Id);
    // message.success(response && response.message);
    const filteredAttachments = correctiveFormObject && correctiveFormObject.CorrectiveActionsAttachments && correctiveFormObject.CorrectiveActionsAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...correctiveFormObject,
      CorrectiveActionsAttachments: filteredAttachments
    };
    setCorrectiveFormObject(data);
  };
  const existingCorrectiveHandleClick = (e, index) => {
    const rowKey = Array.isArray(index) ? index.join('-') : index;

    setSelectedIndexEC(rowKey);
    if (e === 'Add New Attachments') {
      myRef2.current && myRef2.current.click();
    } else {
      setCorrectiveShowusecasedownloadModalExisting(true);
    }
  };
  const correctiveHandleClick = (e, index) => {
    const rowKey = Array.isArray(index) ? index.join('-') : index;

    setSelectedIndex(rowKey);
    if (e === 'Add New Attachments') {
      myRef2.current && myRef2.current.click();
    } else {
      setCorrectiveShowusecasedownloadModal(true);
    }
  };
  const onAnalysisFormSubmit = async () => {
    try {
      // Validate main form first and get its values
      await form2?.validateFields();
      const data = form2?.getFieldsValue();

      // If corrective action is required
      if (status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
        || status === 'Verification InProgress' || status === 'Verification completed' ||
        status === 'Closed'
      ) {

        try {
          const values = await form4?.validateFields();
          const CorrectiveWithAttachments = values.Corrective.map((item, idx) => ({
            ...item,

            CorrectiveActionsAttachments:
              correctiveFormObject.CorrectiveActionsAttachments &&
                correctiveFormObject.CorrectiveActionsAttachments[idx]
                ? correctiveFormObject.CorrectiveActionsAttachments[idx]
                : []
          }));
          const payload = {
            ...values,
            Corrective: CorrectiveWithAttachments,

          };

          if (values && values.Corrective && values.Corrective[0] && values.Corrective[0].Id && values.Corrective[0].Id !== null && values.Corrective[0].Id !== undefined) {
            let payload1 = {
              ReportId: formObject && formObject.ReportId,
              Status: status,
              selectedStatusId: selectedStatusId
            };

            let response = await updateCorrectiveActionsMultiple(payload.Corrective, data.Status, data.Id, values.Corrective[0].DepartmentId);
            if (response?.status === 200) {
              let response1 = await onReportManagerAction(payload1);
              console.log(response1);
              message.success(response.data?.message);
              analysisResetFields();
              correctiveResetFields();
              props.onActiveTabChange('List');
              // setPresentActiveKey('List');
              const analysisList = await getAnalysisList(props.screenName);
              setDataSourceForAnalysis(analysisList);
            }
          } else {
            // let payloadData={
            //   ...payload.Corrective,
            let DepartmentId = props && props.userProfile && props.userProfile.user && props.userProfile.user.DepartmentId;
            // }
            const response = await createCorrectiveActionsMultiple(payload.Corrective, data.Status, data.Id, DepartmentId);
            if (response?.status === 200) {
              message.success(response.data?.message);
              analysisResetFields();
              correctiveResetFields();
              props.onActiveTabChange('List');
              // setPresentActiveKey('List');
              const analysisList = await getAnalysisList(props.screenName);
              setDataSourceForAnalysis(analysisList);
            }
          }

        } catch (error) {
          console.error(error);
          message.error('Please fill all mandatory corrective action fields.');
        }
        return; // Early return to avoid further execution
      } else if (status === 'Analysis Completed') {
        message.warning("Please change the status");
      } else {
        // Otherwise, handle analysis form
        try {
          const values = await form3?.validateFields();

          const formattedValues = {
            ...values,
            AnalysisStartDate: dayjs(values.AnalysisStartDate).format('YYYY-MM-DD HH:mm'),
            AnalysisDueDate: dayjs(values.AnalysisDueDate).format('YYYY-MM-DD HH:mm'),
            AnalysisAttachments: analysisFormObject && analysisFormObject.AnalysisAttachments,
          };
          let payload = {};
          // Create
          if (formattedValues.Id === null) {
            payload = {
              ...formattedValues,
              ReportId: data.Id,
              Status: data.Status,
              selectedStatusId: selectedStatusId,
              UserId: props && props.userProfile && props.userProfile.user && props.userProfile.user.Id,
              DepartmentId: props && props.userProfile && props.userProfile.user && props.userProfile.user.DepartmentId,
              UserName: props && props.userProfile && props.userProfile.user && props.userProfile.user.FirstName,
            };
            const response = await createFailure(payload);

            if (response?.status === 200) {
              message.success(response.data?.message);

              if (response.data?.Status === 'Analysis Completed') {
                setCorrectiveButton(true);
                const [userList, StatusList, editedRow] = await Promise.all([
                  getUserList(),
                  getStatusList(data.Status),
                  getAnalysisByIdMultiple(data.Id, 'Analysis and Corrective Actions'),
                ]);
                setUserList(userList);
                setStatusList(StatusList);
                let selectedStatus = StatusList && StatusList.filter(item => item.NextStatus === data.Status);
                setSelectedStatusId(selectedStatus && selectedStatus[0] && selectedStatus[0].Id);
                const LoginUser = props?.userProfile?.user?.Id;
                const AnalysisDetails = await getAllAnalysisById(data.Id);
                const matchedUser = AnalysisDetails.filter(item => item.CreatedBy === LoginUser);
                const otherUsers = AnalysisDetails.filter(item => item.CreatedBy !== LoginUser);

                const otherAnalysisUsers = otherUsers.map(user => ({
                  ...user,
                  AnalysisStartDate: dayjs(user.AnalysisStartDate),
                  AnalysisDueDate: dayjs(user.AnalysisDueDate),
                }));

                // Step 3: Handle Corrective Actions
                const correctiveEdit = await getCorrectiveByIdMultiple(data.Id);
                const matchedCorrective = correctiveEdit.filter(item => item.UserId === LoginUser);
                const otherCorrective = correctiveEdit.filter(item => item.UserId !== LoginUser);

                if (matchedCorrective.length > 0) {
                  const correctedMapped = matchedCorrective.map(item => ({
                    ...item,
                    CorrectiveActionsAttachments: item.CorrectiveActionsAttachments || [],
                  }));

                  await form4?.setFieldsValue({ Corrective: correctedMapped });
                  setCorrective(correctedMapped);
                  setCorrectiveFormObject(correctedMapped[0]);
                  setCorrectiveButton(false);
                  setCorrectiveStatus('Analysis Completed');
                } else {
                  await form4?.setFieldsValue({ Corrective: [] });
                  setCorrective([]);
                  setCorrectiveFormObject(null);
                  setCorrectiveButton(false);
                  setCorrectiveStatus(null);
                }

                if (otherCorrective.length > 0) {
                  const otherCorrectiveMapped = otherCorrective.map(item => ({
                    ...item,
                    CorrectiveActionsAttachments: item.CorrectiveActionsAttachments || [],
                  }));
                  ExistingCorrectiveRef?.setFieldsValue({ ExistingCorrective: otherCorrectiveMapped });
                  setExistingCorrective(otherCorrectiveMapped);
                } else {
                  ExistingCorrectiveRef?.setFieldsValue({ ExistingCorrective: [] });
                  setExistingCorrective([]);
                }
                if (!editedRow) {
                  console.error('No record found');
                  return;
                }

                const FailureCodeList = await getFailureCodeList(editedRow.Device);
                setFailureCodeList(FailureCodeList);

                // if (editedRow.DepartmentId) {
                //   const usersList = await getUsersList(editedRow.DepartmentId);
                //   setUsersList(usersList);
                // }

                const assignUsers = editedRow.AssignUsers || [];
                const departmentIds = [...new Set(assignUsers.map(u => u.DepartmentId))];
                const allDeptUsers = [];

                for (const deptId of departmentIds) {
                  const users = await getUsersList(deptId);
                  if (Array.isArray(users)) {
                    allDeptUsers.push(...users);
                  }
                }

                setUsersList(allDeptUsers);
                setSelectedDevice(editedRow.Device);
                setFailureTypeId(editedRow.FailureTypeId);

                const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
                setQuestionsList(questionsList);

                // Step 6: Set Form 2 (Main Form)
                const formValues = {
                  ...editedRow,
                  Id: editedRow.ReportId,
                  OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
                  ReportedDate: dayjs(editedRow.ReportedDate),
                  ReportedBy: editedRow.ReportedName,
                  ReportID: editedRow.ReportId,
                };

                await form2?.setFieldsValue(formValues);
                setFormObject(formValues);

                // Step 7: Set Form 3 (Analysis Form)
                const userAnalysis = matchedUser && matchedUser[0];

                if (userAnalysis) {
                  const analysisFormValues = {
                    Id: userAnalysis.Id,
                    AnalysisStartDate: dayjs(userAnalysis.AnalysisStartDate).utc(),
                    AnalysisDueDate: dayjs(userAnalysis.AnalysisDueDate).utc(),
                    ChangeRecommendations: userAnalysis.ChangeRecommendations,
                    FailureCause: userAnalysis.FailureCause,
                    ContributingFactors: userAnalysis.ContributingFactors,
                    AnalysisComments: userAnalysis.AnalysisComments,
                    AnalysisAttachments: userAnalysis.AnalysisAttachments,
                  };

                  await form3?.setFieldsValue(analysisFormValues);
                  setAnalysisFormObject(analysisFormValues);
                } else {
                  await form3?.setFieldsValue({
                    Id: null,
                    AnalysisStartDate: null,
                    AnalysisDueDate: null,
                    ChangeRecommendations: null,
                    FailureCause: null,
                    ContributingFactors: null,
                    AnalysisComments: null,
                    AnalysisAttachments: [],
                  });
                  setAnalysisFormObject({
                    Id: null,
                    AnalysisStartDate: null,
                    AnalysisDueDate: null,
                    ChangeRecommendations: null,
                    FailureCause: null,
                    ContributingFactors: null,
                    AnalysisComments: null,
                    AnalysisAttachments: [],
                  });
                }

                if (otherAnalysisUsers.length > 0) {
                  AnalysisRef?.setFieldsValue({ AnalysisValues: otherAnalysisUsers });
                  setAnalysisValues(otherAnalysisUsers);
                } else {
                  AnalysisRef?.setFieldsValue({ AnalysisValues: [] });
                  setAnalysisValues([]);
                }

                // Step 8: Final Form Assignments
                if (editedRow.FracasStatus === 'Analysis Completed') {
                  setCorrectiveButton(true);
                }

                setStatus(editedRow.FracasStatus);

                DepartmentRef1?.setFieldsValue({
                  Users: assignUsers,
                });

                setUsers(assignUsers);

                await QuestionRef?.setFieldsValue({
                  Questions: editedRow.Questions,
                });

                setQuestions(editedRow.Questions);

              } else {
                analysisResetFields();
                props.onActiveTabChange('List');
                // setPresentActiveKey('List');
                const analysisList = await getAnalysisList(props.screenName);
                setDataSourceForAnalysis(analysisList);
              }
            } else {
              setCorrectiveStatus(null);
              // message.warning('Error while creating analysis');
            }
          } else {
            // Update
            payload = {
              ...formattedValues,
              ReportId: data.Id,
              Id: formattedValues.Id,
              Status: data.Status,
              selectedStatusId: selectedStatusId
            };
            const response = await updateFailure(payload);

            if (response?.status === 200) {
              message.success(response.data?.message);
              analysisResetFields();
              props.onActiveTabChange('List');
              // setPresentActiveKey('List');
              const analysisList = await getAnalysisList(props.screenName);
              setDataSourceForAnalysis(analysisList);
            } else {
              message.warning('Error while updating analysis');
            }
          }
        } catch (error) {
          message.error('Please add mandatory fields in analysis form');
        }
      }


    } catch (error) {
      message.error('Please fill all mandatory fields in the main form');
    }
  };
  const analysisFileUpload = (info) => {
    if (info.file.status === 'done') {
      let id =
        info && info.file && info.file.response && info.file.response && info.file.response.Id;
      let Name =
        info && info.file && info.file.response && info.file.response && info.file.response.Name;
      if (analysisFormObject) {
        if (analysisFormObject['AnalysisAttachments']) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];

          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject['AnalysisAttachments'] = [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      } else {
        if (analysisFormObject && analysisFormObject['AnalysisAttachments'] && analysisFormObject['AnalysisAttachments'].length !== 0) {
          analysisFormObject['AnalysisAttachments'] =
            analysisFormObject && analysisFormObject['AnalysisAttachments'] ? analysisFormObject['AnalysisAttachments'] : [];
          analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        } else {
          analysisFormObject &&
            analysisFormObject['AnalysisAttachments'] &&
            analysisFormObject['AnalysisAttachments'].push({ Id: id, file: Name });
        }
      }

      setAnalysisFormObject(analysisFormObject);
      // this.hForm.current.setFieldsValue(formObject);
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
  const analysisHandleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef1.current && myRef1.current.click();
    } else {
      setAnalysisShowusecasedownloadModal(true);
    }
  };
  const disabledEndDate = (current) => {
    const startDate = form3?.getFieldValue?.('AnalysisStartDate');
    if (!startDate) {
      // If no start date selected, allow all dates
      return false;
    }
    // Disable dates before the selected start date
    return current && current.isBefore(dayjs(startDate), 'day');
  };
  const AnalysisDeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = analysisFormObject && analysisFormObject.AnalysisAttachments && analysisFormObject.AnalysisAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...analysisFormObject,
      AnalysisAttachments: filteredAttachments
    };
    setAnalysisFormObject(data);
  };
  const CorrectiveDeleteAttachmentFun = async (record) => {
    let response = await DeleteAttachment(record.Id);
    message.success(response && response.message);
    const filteredAttachments = correctiveFormObject && correctiveFormObject.CorrectiveActionsAttachments && correctiveFormObject.CorrectiveActionsAttachments.filter(item => item.Id !== record.Id);
    let data = {
      ...correctiveFormObject,
      CorrectiveActionsAttachments: filteredAttachments
    };
    setCorrectiveFormObject(data);
  };
  const getColumnSearchPropsFailureAnalysis = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        {dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate' ? (
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] ? dayjs(selectedKeys[0], 'YYYY-MM-DD HH:mm') : null}
            onChange={(value) =>
              setSelectedKeys(value ? [value.format('YYYY-MM-DD HH:mm')] : [])
            }
            onPressEnter={() => handleSearchFailureAnalysis(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        ) : (
          <Input
            ref={failureInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearchFailureAnalysis(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
        )}
        <Button
          type="primary"
          onClick={() => handleSearchFailureAnalysis(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleResetFailureAnalysis(clearFilters, confirm, dataIndex)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      if (!record || !record[dataIndex]) return false;
      if (dataIndex === 'OccuranceDate ' || dataIndex === 'ReportedDate') {
        // Compare full date and time string
        return dayjs(record[dataIndex]).format('YYYY-MM-DD HH:mm') === value;
      }
      return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
    },
    render: (text) =>
      dataIndex === 'OccuranceDate' || dataIndex === 'ReportedDate'
        ? text
          ? moment(text).format('YYYY-MM-DD HH:mm')
          : null
        : (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={failureText[dataIndex] ? [failureText[dataIndex]] : []}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ),
  });

  const handleSearchFailureAnalysis = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
    setFailureText(prev => ({
      ...prev,
      [dataIndex]: selectedKeys[0] || ''
    }));
  };
  const handleResetFailureAnalysis = (clearFilters, confirm, dataIndex) => {
    clearFilters();
    setSearchedColumn('');
    confirm();
    setFailureText(prev => ({
      ...prev,
      [dataIndex]: ''
    }));
  };
  const AnalysisEdit = async (record, key) => {
    props.onActiveTabChange('Details');
    // setPresentActiveKey('Details');
    setSelectedKey(key);
    let HierarchyData = await getUserHeirarchyData();
    let permissionsArray =
      HierarchyData &&
      HierarchyData['belongsTo'] &&
      HierarchyData['belongsTo']['sites'] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')] &&
      HierarchyData['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];

    const EquipmentList = await getHierarchyTreeData(
      permissionsArray && permissionsArray[0] && permissionsArray[0].HierarchyName
    );
    setEquipmentList(EquipmentList);
    let FailureTypeList = await getFailureList();
    setFailureTypeList(FailureTypeList);
    let SeverityList = await getSeverityList();
    setSeverityList(SeverityList);
    let departmentList = await getDepartmentList();
    setDepartmentList(departmentList);
    let userList = await getUserList();
    setUserList(userList);
    try {
      const LoginUser = props?.userProfile?.user?.Id;

      // Step 1: Fetch all necessary data in parallel
      const [statusList, editedRow] = await Promise.all([
        getStatusList(record.Status),
        getAnalysisByIdMultiple(record.Id, 'Analysis and Corrective Actions'),
      ]);

      setUserList(userList);
      setStatusList(statusList);
      // let selectedStatusId = statusList && statusList.filter(item=>item.NextStatus === record.Status);
      // console.log(selectedStatusId,'yjhrfcgfg',statusList,record.Status);

      // setSelectedStatusId(selectedStatusId);
      // Step 2: Fetch all analysis details
      const AnalysisDetails = await getAllAnalysisById(record.Id);
      const matchedUser = AnalysisDetails.filter(item => item.CreatedBy === LoginUser);
      const otherUsers = AnalysisDetails.filter(item => item.CreatedBy !== LoginUser);
      const otherAnalysisUsers = otherUsers.map(user => ({
        ...user,
        AnalysisStartDate: dayjs(user.AnalysisStartDate),
        AnalysisDueDate: dayjs(user.AnalysisDueDate),
      }));

      // Step 3: Handle Corrective Actions
      const correctiveEdit = await getCorrectiveByIdMultiple(record.Id);
      const matchedCorrective = correctiveEdit.filter(item => item.CreatedBy === LoginUser);
      const otherCorrective = correctiveEdit.filter(item => item.CreatedBy !== LoginUser);

      if (matchedCorrective.length > 0) {
        const correctedMapped = matchedCorrective.map(item => ({
          ...item,
          CorrectiveActionsAttachments: item.CorrectiveActionsAttachments || [],
        }));

        let extractedAttachments = {};
        matchedCorrective.forEach((item, index) => {
          extractedAttachments[index] = item.CorrectiveActionsAttachments;
        });

        await form4?.setFieldsValue({ Corrective: correctedMapped });
        setCorrective(correctedMapped);
        setCorrectiveFormObject({ CorrectiveActionsAttachments: extractedAttachments });
        setCorrectiveButton(false);
        setCorrectiveStatus('Analysis Completed');
      } else {
        await form4?.setFieldsValue({ Corrective: [] });
        setCorrective([]);
        setCorrectiveFormObject(null);
        setCorrectiveButton(false);
        setCorrectiveStatus(null);
      }

      if (otherCorrective.length > 0) {
        const otherCorrectiveMapped = otherCorrective.map(item => ({
          ...item,
          CorrectiveActionsAttachments: item.CorrectiveActionsAttachments || [],
        }));
        ExistingCorrectiveRef?.setFieldsValue({ ExistingCorrective: otherCorrectiveMapped });
        setExistingCorrective(otherCorrectiveMapped);
      } else {
        ExistingCorrectiveRef?.setFieldsValue({ ExistingCorrective: [] });
        setExistingCorrective([]);
      }

      // Step 4: Ensure analysis record exists
      if (!editedRow) {
        console.error('No record found');
        return;
      }

      // Step 5: Set failure codes, user list, and questions
      const failureCodeList = await getFailureCodeList(editedRow.Device);
      setFailureCodeList(failureCodeList);

      const assignUsers = editedRow.AssignUsers || [];
      const departmentIds = [...new Set(assignUsers.map(u => u.DepartmentId))];
      const allDeptUsers = [];

      for (const deptId of departmentIds) {
        const users = await getUsersList(deptId);
        if (Array.isArray(users)) {
          allDeptUsers.push(...users);
        }
      }

      setUsersList(allDeptUsers);
      setSelectedDevice(editedRow.Device);
      setFailureTypeId(editedRow.FailureTypeId);

      const questionsList = await getQuestionsList(editedRow.FailureTypeId, editedRow.Device);
      setQuestionsList(questionsList);

      // Step 6: Set Form 2 (Main Form)
      const formValues = {
        ...editedRow,
        Id: editedRow.ReportId,
        OccuranceDate: dayjs(editedRow.OccuranceDate).utc(),
        ReportedDate: dayjs(editedRow.ReportedDate),
        ReportedBy: editedRow.ReportedName,
        ReportID: editedRow.ReportIds,
        Status: editedRow.FracasStatus
      };

      await form2?.setFieldsValue(formValues);
      setFormObject(formValues);

      // Step 7: Set Form 3 (Analysis Form)
      const userAnalysis = matchedUser && matchedUser[0];
      if (userAnalysis) {
        const analysisFormValues = {
          Id: userAnalysis.Id,
          AnalysisStartDate: dayjs(userAnalysis.AnalysisStartDate).utc(),
          AnalysisDueDate: dayjs(userAnalysis.AnalysisDueDate).utc(),
          ChangeRecommendations: userAnalysis.ChangeRecommendations,
          FailureCause: userAnalysis.FailureCause,
          ContributingFactors: userAnalysis.ContributingFactors,
          AnalysisComments: userAnalysis.AnalysisComments,
          AnalysisAttachments: userAnalysis.AnalysisAttachments,
        };

        await form3?.setFieldsValue(analysisFormValues);
        setAnalysisFormObject(analysisFormValues);
      } else {
        await form3?.setFieldsValue({
          Id: null,
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: [],
        });
        // setAnalysisFormObject({});
        setAnalysisFormObject({
          Id: null,
          AnalysisStartDate: null,
          AnalysisDueDate: null,
          ChangeRecommendations: null,
          FailureCause: null,
          ContributingFactors: null,
          AnalysisComments: null,
          AnalysisAttachments: []
        });
      }

      if (otherAnalysisUsers.length > 0) {
        AnalysisRef?.setFieldsValue({ AnalysisValues: otherAnalysisUsers });
        setAnalysisValues(otherAnalysisUsers);
      } else {
        AnalysisRef?.setFieldsValue({ AnalysisValues: [] });
        setAnalysisValues([]);
      }

      // Step 8: Final Form Assignments
      if (editedRow.FracasStatus === 'Analysis Completed') {
        setCorrectiveButton(true);
      }

      setStatus(editedRow.FracasStatus);
      DepartmentRef1?.setFieldsValue({
        Users: assignUsers,
      });

      setUsers(assignUsers);

      await QuestionRef?.setFieldsValue({
        Questions: editedRow.Questions,
      });

      setQuestions(editedRow.Questions);
    } catch (error) {
      console.error('Error editing record:', error);
    }
  };
  const UseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => DeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const AnalysisUseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (

        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onAnalysisAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => AnalysisDeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const CorrectiveActionsUseCaseColumns = [
    {
      title: translation('File'),
      dataIndex: 'file',
      key: 'file',
      align: 'center'
    },
    {
      title: translation('Action'),
      width: '600',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <>
            <Tooltip placement="top" key="download" title="Download">
              <div>
                <a href={`${IPAddress.LOCAL}${API_FRACAS.FracasAttachments}/${record.file}`}>
                  {' '}
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          </>
          {selectedKey !== 'view' && (
            record && !record.ReportId ? (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={(e) => onCorrectiveAttachmentDelete(e, record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            ) : (
              <Popconfirm
                title={translation("Are you sure that you want to delete the file")}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={() => CorrectiveDeleteAttachmentFun(record)}
                okText={translation('Yes')}
                cancelText={translation('No')}
              >
                <div style={{ marginLeft: '15px' }}>
                  <Tooltip title={translation('Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </div>
              </Popconfirm>
            )
          )}
        </div>
      )
    }
  ];
  const FailureAnalysisColumns = [
    {
      title: translation('ReportID'),
      dataIndex: 'ReportId',
      key: 'ReportId',
      ...getColumnSearchPropsFailureAnalysis('ReportId')
    },
    {
      title: translation('Equipment'),
      dataIndex: 'EquipmentCode',
      key: 'EquipmentCode',
      ...getColumnSearchPropsFailureAnalysis('EquipmentCode')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName',
      ...getColumnSearchPropsFailureAnalysis('FailureTypeName')
    },
    {
      title: translation('Severity'),
      dataIndex: 'SeverityName',
      key: 'SeverityName',
      ...getColumnSearchPropsFailureAnalysis('SeverityName')
    },
    {
      title: translation('Detection Source'),
      dataIndex: 'DetectionSource',
      key: 'DetectionSource',
      ...getColumnSearchPropsFailureAnalysis('DetectionSource')
    },
    {
      title: translation('Occurred Date&Time'),
      dataIndex: 'OccuranceDate',
      key: 'OccuranceDate',
      sorter: (a, b) => dayjs(a.OccuranceDate) - dayjs(b.OccuranceDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchPropsFailureAnalysis('OccuranceDate'),
      render: (text) => {
        return {
          children:
            text !== undefined && text !== null ? (
              <div>{dayjs(text).utc().format('YYYY-MM-DD HH:mm')}</div>
            ) : null
        };
      }
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchPropsFailureAnalysis('Status')
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (

        <>
          {record.Status === 'Closed' || record.Status === 'Verification completed' || record.Status === 'Reject' ?
            <>
              <Button type="primary" onClick={() => AnalysisEdit(record, 'view')}>
                <Tooltip title={translation('View')}>
                  <EyeOutlined />
                </Tooltip>
              </Button>
            </>
            :
            <>
              <Button type="primary" onClick={() => AnalysisEdit(record, 'edit')}>
                <Tooltip title={translation('Edit')}>
                  <EditOutlined />
                </Tooltip>
              </Button>
            </>
          }
        </>
      )
    }
  ];
  const formItemLayout = { width: '100%', flex: '50%' };
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  let colorBgContainer = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgContainer;


  return (
    <div >

      <Tabs
        defaultActiveKey="List"
        activeKey={presentActiveKey}
      >
        <TabPane tab={'List'} key="List">
          <StyledTable size="small"
            columns={FailureAnalysisColumns}
            dataSource={dataSourceForAnalysis}
            style={{ marginTop: '24px' }}
            pagination={{
              current,
              onChange: (page) => setCurrent(page),
            }}
            onChange={props.handleTableChange}
          />
        </TabPane>
        <TabPane tab={'Details'} key="Details">
          <div style={{ padding: '10px 0px' }}>
            <div style={{ cursor: 'pointer' }}>
              <Button type='primary' style={{ cursor: 'pointer' }}
                onClick={() => props.onActiveTabChange('List')}
              >
                <RollbackOutlined />
                {translation('Go Back')}
              </Button>
            </div>
          </div>
          <Form
            name="FailureReport_Analysis"
            ref={h2Ref}
            form={form2}
            autoComplete="off"
            initialValues={formObject}
            layout="vertical"
            onFinish={onAnalysisFormSubmit}
            onFinishFailed={onAnalysisFinishFailed}
            labelWrap
          >
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Collapse
                defaultActiveKey={['1']}
                style={{ width: '100%' }}
                expandIcon={({ isActive }) =>
                  isActive ? <UpOutlined /> : <DownOutlined />
                }
              >
                <Panel header="Reporting Details" key="1">

                  <div >
                    <Row gutter={16}>
                      <Form.Item name="Id"></Form.Item>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name="Device"
                          label={translation(`Equipment`)}
                          rules={[{ required: true, message: translation("Please Select Equipment!") }]}
                        >
                          <div style={{ display: 'flex', gap: '1%', flexWrap: 'wrap', width: '100%' }}>
                            <Select
                              style={{ flex: 1 }}
                              value={selectedDevice}
                              placeholder={translation('Select Equipment')}
                              disabled={true}
                            >
                              {devicesList?.map((eqp, index) => (
                                <Option key={index} value={eqp.AliasCode}>
                                  {`${eqp.DisplayCode}`}
                                </Option>
                              ))}
                            </Select>
                            <Button
                              type="primary"
                              onClick={() => setTreeVisible(true)}
                              disabled={formObject.Id}
                            >
                              <UpSquareOutlined />
                            </Button>
                          </div>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Type')}
                          name="FailureTypeId"
                          rules={[{ required: true, message: translation("Please Select Failure Type!") }]}
                        >
                          <Select
                            disabled={formObject.Id}
                            placeholder={translation('Select Failure Type')}
                            style={{ width: '100%' }}
                          >
                            {FailureTypeList?.map((device, index) => (
                              <Option key={index} value={device.Id}>
                                {device.Name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Fault Code')}
                          name="FaultCode"
                          rules={[{ required: true, message: translation("Please Select Fault Code!") }]}
                        >
                          <Select
                            disabled={formObject.Id}
                            placeholder={translation('Select Fault Code')}
                            style={{ width: '100%' }}
                          >
                            {FailureCodeList?.map((FailureCode, index) => (
                              <Option key={index} value={FailureCode.VendorCode}>
                                {FailureCode.ParameterDescription}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Severity')}
                          name="SeverityId"
                          rules={[{ required: true, message: translation("Please Select Severity!") }]}
                        >
                          <Select
                            disabled={formObject.Id}
                            placeholder={translation('Select Severity')}
                            style={{ width: '100%' }}
                          >
                            {SeverityList?.map((device, index) => (
                              <Option key={index} value={device.Id}>
                                {device.Name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Occurred Date&Time')}
                          name="OccuranceDate"
                          rules={[{ required: true, message: translation("Please Select Failure Occurred Date&Time!") }]}
                        >
                          <DatePicker
                            showTime={{ format: 'HH:mm' }}
                            placeholder="Select Occurance Date"
                            inputReadOnly={true}
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD HH:mm"
                            disabledDate={disabledDate}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Occurrence Count')}
                          name="OccuranceCount"
                          rules={[{ required: true, message: translation("Please input Failure Occurrence Count!") }]}
                        >
                          <Input
                            type="number"
                            onKeyDown={(e) => {
                              if ([8].includes(e.keyCode)) return;
                              if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
                                e.preventDefault();
                              }
                            }}
                            placeholder={translation('Failure Occurrence Count')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Description')}
                          name="FailureDescription"
                        >
                          <TextArea
                            placeholder={translation('Failure Description')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Impact')}
                          name="Impact"
                        >
                          <TextArea
                            placeholder={translation('Add Failure Impact')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Comments')}
                          name="Comments"
                        >
                          <TextArea
                            placeholder={translation('Add Comments')}
                            style={{ width: '100%' }}
                            disabled={formObject.Id}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Failure Reported Date')}
                          name="ReportedDate"
                        >
                          <DatePicker
                            format={'YYYY-MM-DD HH:mm'}
                            placeholder={translation('Failure Reported Date')}
                            style={{ width: '100%' }}
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          name="Attachments"
                          label={translation('Attachments')}
                        >
                          <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                            <Button
                              onClick={() => handleClick('Add New Attachments')}
                              style={{ flex: 1 }}
                              disabled={formObject?.Id}
                            >
                              <CloudUploadOutlined /> Upload files
                            </Button>
                            <Button onClick={() => handleClick('View Attachments')} style={{ flex: 1 }}>
                              <EyeOutlined /> View files
                            </Button>
                          </div>
                          <Upload
                            multiple={true}
                            beforeUpload={beforeUpload}
                            onChange={(info) => fileUpload(info)}
                            action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=Reporting`}
                            headers={{ Authorization }}
                            showUploadList={false}
                          >
                            <Button style={{ display: 'none' }} ref={myRef} className="uploadFile">
                              <UploadOutlined /> Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Status')}
                          name="Status"
                        >
                          <Select
                            disabled={selectedKey === 'view' || (correctiveButton === true && formObject.Status === 'Analysis Completed')}
                            placeholder={translation('Select Status')}
                            onChange={onStatusChange}
                            style={{ width: '100%' }}
                          >
                            {statusList?.map((status, index) => (
                              <Option key={index} value={status.NextStatus}>
                                {status.NextStatus}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Reported By')}
                          name="ReportedBy"
                        >
                          <Select
                            disabled={true}
                            placeholder={translation('Select Reported By')}
                            style={{ width: '100%' }}
                          >
                            {userList?.map((user, index) => (
                              <Option key={index} value={user.Id}>
                                {user.Name}

                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Form.Item
                          label={translation('Report ID')}
                          name="ReportID"
                        >
                          <Input
                            disabled={true}
                            placeholder={translation('Select Report ID')}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <div style={{ marginTop: '20px' }}>
                      <Collapse
                        defaultActiveKey={['1']}
                        style={{ width: '100%' }}
                        expandIcon={({ isActive }) => isActive ? <UpOutlined /> : <DownOutlined />}
                      >
                        <Panel header="Questions" key="1">
                          <Form
                            name="dynamic_form_nest_item_Analysis"
                            autoComplete="off"
                            form={QuestionRef}
                            initialValues={{ Questions }}
                            layout="vertical"
                            className="Answers_Form"
                          >
                            <div style={{ maxWidth: 800 }}>
                              <Form.List name="Questions">
                                {(fields) => (
                                  <>
                                    {fields.map(({ key, name, ...restField }) => (
                                      <Row gutter={16} key={key}>
                                        <Col xs={24} sm={24} md={12}>
                                          <Form.Item
                                            label="Question"
                                            {...restField}
                                            name={[name, 'QuestionId']}
                                            rules={[{ required: true, message: 'Missing Question' }]}
                                          >
                                            <Select
                                              showSearch
                                              placeholder="Question"
                                              disabled={formObject.Id}
                                              optionFilterProp="children"
                                              filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                              }
                                            >
                                              {questionsList?.map((item, index) => (
                                                <Option key={index} value={item.Id}>
                                                  {item.Question}
                                                </Option>
                                              ))}
                                            </Select>
                                          </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={24} md={12}>
                                          <Form.Item
                                            label="Answer"
                                            {...restField}
                                            name={[name, 'Answers']}
                                            rules={[{ required: true, message: 'Missing Answer' }]}
                                          >
                                            <Input
                                              disabled={formObject.Id}
                                              placeholder="Answer"
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                    ))}
                                  </>
                                )}
                              </Form.List>
                            </div>

                          </Form>
                        </Panel>
                      </Collapse>
                    </div>

                  </div>
                </Panel>
              </Collapse>
            </div>
            <div
              style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}

            >
              <Collapse
                defaultActiveKey={['1']}
                style={{ width: '100%' }}
                expandIcon={({ isActive }) =>
                  isActive ? <UpOutlined /> : <DownOutlined />
                }
              >
                <Panel header="Analysis Details" key="1">

                  <Form
                    name="FailureReport_Analysis_Details"
                    ref={h3Ref}
                    form={form3}
                    autoComplete="off"
                    initialValues={analysisFormObject}
                    layout="vertical"
                    labelWrap
                  >
                    <Row gutter={16}>

                      <Form.Item name="Id"></Form.Item>

                      <Col xs={24} sm={12} md={6}>
                        <Form.Item
                          name="AnalysisStartDate"
                          label={translation(`Analysis Start Date`)}
                          rules={[
                            {
                              required: true,
                              message: translation("Please Select Analysis Start Date!"),
                            },
                          ]}
                          style={formItemLayout}
                        >
                          <DatePicker
                            showTime={true}
                            showNow={false}
                            disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                              status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                              || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && (analysisFormObject && analysisFormObject.Id)}
                            placeholder="Select Analysis Start Date"
                            inputReadOnly={true}
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD HH:mm"
                            disabledDate={(d) => {
                              const now = dayjs();
                              const reportedDateValue = form2?.getFieldValue('ReportedDate');
                              const analysisDueDateValue = form3?.getFieldValue('AnalysisDueDate');
                              const reportedDate = reportedDateValue ? dayjs(reportedDateValue) : null;
                              const analysisDueDate = analysisDueDateValue ? dayjs(analysisDueDateValue) : null;

                              let minDate = now;
                              if (reportedDate && reportedDate.isAfter(now)) {
                                minDate = reportedDate;
                              }

                              return (
                                !d ||
                                d.add(1, 'day').isBefore(minDate) ||
                                (analysisDueDate && d.isAfter(analysisDueDate))
                              );
                            }}
                            disabledTime={(current) => {
                              let FromTime = form2?.getFieldValue('ReportedDate');
                              let currentTime = dayjs();
                              if (!FromTime || !current) {
                                return {};
                              }
                              const disabledHours = [];
                              const disabledMinutes = [];
                              const disabledSeconds = [];
                              if (current.isSame(FromTime, 'day')) {
                                for (let i = 0; i < FromTime.hour(); i++) {
                                  disabledHours.push(i);
                                }
                                if (current.hour() === FromTime.hour()) {
                                  for (let i = 0; i < FromTime.minute(); i++) {
                                    disabledMinutes.push(i);
                                  }
                                  if (current.minute() === FromTime.minute()) {
                                    for (let i = 0; i < FromTime.second(); i++) {
                                      disabledSeconds.push(i);
                                    }
                                  }
                                }
                              }
                              if (current.isSame(currentTime, 'day')) {
                                for (let i = 0; i < currentTime.hour(); i++) {
                                  disabledHours.push(i);
                                }
                                if (current.hour() === currentTime.hour()) {
                                  for (let i = 0; i < currentTime.minute(); i++) {
                                    disabledMinutes.push(i);
                                  }
                                  if (current.minute() === currentTime.minute()) {
                                    for (let i = 0; i < currentTime.second(); i++) {
                                      disabledSeconds.push(i);
                                    }
                                  }
                                }
                              }
                              return {
                                disabledHours: () => disabledHours,
                                disabledMinutes: () => disabledMinutes,
                                disabledSeconds: () => disabledSeconds
                              };
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={6}>
                        <Form.Item
                          label={translation('Analysis Due Date')}
                          name="AnalysisDueDate"
                          rules={[
                            {
                              required: true,
                              message: translation("Please Select Analysis Due Date!"),
                            },
                          ]}
                          style={formItemLayout}
                        >
                          <DatePicker
                            showTime={true}
                            showNow={false}
                            disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                              status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                              || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && (analysisFormObject && analysisFormObject.Id)}
                            placeholder="Select Analysis Due Date"
                            inputReadOnly={true}
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD HH:mm"
                            disabledDate={disabledEndDate}
                            disabledTime={(current) => {
                              let FromTime = form3?.getFieldValue('AnalysisStartDate');
                              let currentTime = dayjs();
                              if (!FromTime || !current) {
                                return {};
                              }
                              const disabledHours = [];
                              const disabledMinutes = [];
                              const disabledSeconds = [];
                              if (current.isSame(FromTime, 'day')) {
                                for (let i = 0; i < FromTime.hour(); i++) {
                                  disabledHours.push(i);
                                }
                                if (current.hour() === FromTime.hour()) {
                                  for (let i = 0; i < FromTime.minute(); i++) {
                                    disabledMinutes.push(i);
                                  }
                                  if (current.minute() === FromTime.minute()) {
                                    for (let i = 0; i < FromTime.second(); i++) {
                                      disabledSeconds.push(i);
                                    }
                                  }
                                }
                              }
                              if (current.isSame(currentTime, 'day')) {
                                for (let i = 0; i < currentTime.hour(); i++) {
                                  disabledHours.push(i);
                                }
                                if (current.hour() === currentTime.hour()) {
                                  for (let i = 0; i < currentTime.minute(); i++) {
                                    disabledMinutes.push(i);
                                  }
                                  if (current.minute() === currentTime.minute()) {
                                    for (let i = 0; i < currentTime.second(); i++) {
                                      disabledSeconds.push(i);
                                    }
                                  }
                                }
                              }
                              return {
                                disabledHours: () => disabledHours,
                                disabledMinutes: () => disabledMinutes,
                                disabledSeconds: () => disabledSeconds
                              };
                            }}
                          />
                        </Form.Item>
                      </Col>


                      <Col xs={24} sm={12} md={6}>
                        <Form.Item
                          style={formItemLayout}
                          name="AnalysisAttachments"
                          label={translation('Analysis Attachments')}
                        >
                          <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                            <Button
                              onClick={() => analysisHandleClick('Add New Attachments')}
                              disabled={(status === 'Analysis Completed' && formObject.Id) || (selectedKey === 'view') ||
                                status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                                || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed'}>
                              <CloudUploadOutlined /> Upload files
                            </Button>
                            <Button onClick={() => analysisHandleClick('View Attachments')} >
                              <EyeOutlined /> View files
                            </Button>
                          </div>
                          <Upload
                            multiple={true}
                            beforeUpload={(file) => {
                              const isAllowedType =
                                file.type === 'image/jpeg' ||
                                file.name.endsWith('.jpg') ||
                                file.name.endsWith('.jpeg') ||
                                file.name.endsWith('.pdf') ||
                                file.name.endsWith('.png') ||
                                file.name.endsWith('.ppt') ||
                                file.name.endsWith('.pptx') ||
                                file.name.endsWith('.xls') ||
                                file.name.endsWith('.xlsx') ||
                                file.name.endsWith('.docx') ||
                                file.name.endsWith('.doc');

                              if (!isAllowedType) {
                                message.error(`You cannot upload ${file.type} files!`);
                              }

                              const isLt2M = file.size / 1024 / 1024 < 2;
                              if (!isLt2M) {
                                message.error('File must be smaller than 2MB!');
                              }
                              return isAllowedType && isLt2M;
                            }}
                            onChange={(info) => analysisFileUpload(info)}
                            action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=Analysis`}
                            headers={{
                              Authorization: Authorization
                            }}
                            showUploadList={false}
                          >
                            <Button style={{ display: 'none' }} ref={myRef1} className="uploadFile">
                              <UploadOutlined /> Upload
                            </Button>
                          </Upload>

                          <Drawer
                            title="Failure Analysis Uploaded Files"
                            open={analysisShowusecasedownloadModal}
                            width={'50%'}
                            onOk={() => setAnalysisShowusecasedownloadModal(false)}
                            onClose={() => setAnalysisShowusecasedownloadModal(false)}
                          >
                            <StyledTable
                              size="small"
                              columns={AnalysisUseCaseColumns}
                              dataSource={
                                analysisFormObject &&
                                  analysisFormObject.AnalysisAttachments &&
                                  Array.isArray(analysisFormObject.AnalysisAttachments) &&
                                  analysisFormObject.AnalysisAttachments
                                  ? [...analysisFormObject.AnalysisAttachments]
                                  : []
                              }
                            />
                          </Drawer>
                        </Form.Item>
                      </Col>


                      <Col xs={24} sm={12} md={6}>
                        <Form.Item
                          label={translation('Failure Cause')}
                          name="FailureCause"
                          style={formItemLayout}
                        >
                          <TextArea
                            disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                              status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                              || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && (analysisFormObject && analysisFormObject.Id)}
                            placeholder="Input Failure Cause"
                            style={{
                              width: '100%'
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={6}>
                        <Form.Item
                          label={translation('Contributing Factors')}
                          name="ContributingFactors"
                          style={formItemLayout}
                        >
                          <TextArea
                            disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                              status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                              || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && (analysisFormObject && analysisFormObject.Id)}
                            placeholder="Input Contributing Factors"
                            style={{
                              width: '100%'
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12} md={6}>
                        <Form.Item
                          label={translation('Analysis Description')}
                          name="AnalysisComments"
                          style={formItemLayout}
                        >
                          <TextArea
                            disabled={(status === 'Analysis Completed' || selectedKey === 'view' ||
                              status === 'Corrective Action Proposed' || status === 'Corrective Action Implemented'
                              || status === 'Verification completed' || status === 'Verification InProgress' || status === 'Closed') && (analysisFormObject && analysisFormObject.Id)}
                            placeholder="Input Analysis Description"
                            style={{
                              width: '100%'
                            }}
                          />
                        </Form.Item>
                      </Col>

                    </Row>
                  </Form>
                  <Form
                    name="dynamic_form_nest_item_AD"
                    autoComplete="off"
                    ref={CARef}
                    form={AnalysisRef}
                    initialValues={{ AnalysisValues: AnalysisValues }}
                    style={{ width: '100%' }}
                    layout="vertical"
                    className="Answers_Form"
                  >
                    <Form.List name="AnalysisValues">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }, index) => (
                            <Collapse
                              defaultActiveKey={['1']}
                              style={{ width: '100%' }}
                              expandIcon={({ isActive }) =>
                                isActive ? <UpOutlined /> : <DownOutlined />
                              }
                              key={name}
                            >
                              <Panel
                                header={
                                  <span>
                                    <span style={{ fontWeight: 'bold' }}>{'UserName'}</span> :
                                    <span style={{ margin: '0px 8px' }}>
                                      {AnalysisValues[name].FirstName},
                                    </span>
                                    <span style={{ fontWeight: 'bold' }}>
                                      {'Department Name'}
                                    </span>{' '}
                                    :
                                    <span style={{ margin: '0px 8px' }}>
                                      {AnalysisValues[name].Name}
                                    </span>
                                  </span>
                                }
                                key="1"
                              >
                                <Row gutter={16}>
                                  <Col xs={24} sm={12} md={6} lg={6}>
                                    <Form.Item
                                      label={translation('Analysis Start Date')}
                                      {...restField}
                                      name={[name, 'AnalysisStartDate']}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please Select Analysis Start Date!',
                                        },
                                      ]}
                                    >
                                      <DatePicker
                                        showTime
                                        disabled={true}
                                        placeholder="Select Analysis Start Date"
                                        inputReadOnly
                                        style={{ width: '100%' }}
                                        format="YYYY-MM-DD HH:mm"
                                      // your disabledDate and disabledTime logic here
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={6}>
                                    <Form.Item
                                      label={translation('Analysis Due Date')}
                                      {...restField}
                                      name={[name, 'AnalysisDueDate']}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please Select Analysis Due Date',
                                        },
                                      ]}
                                    >
                                      <DatePicker
                                        showTime={true}
                                        showNow={false}
                                        disabled={true}
                                        placeholder="Select Analysis Due Date"
                                        inputReadOnly={true}
                                        style={{ width: '100%' }}
                                        format="YYYY-MM-DD HH:mm"
                                        disabledDate={disabledEndDate}
                                        disabledTime={(current) => {
                                          let FromTime = form3?.getFieldValue('AnalysisStartDate');
                                          let currentTime = dayjs();
                                          if (!FromTime || !current) {
                                            return {};
                                          }
                                          const disabledHours = [];
                                          const disabledMinutes = [];
                                          const disabledSeconds = [];
                                          if (current.isSame(FromTime, 'day')) {
                                            for (let i = 0; i < FromTime.hour(); i++) {
                                              disabledHours.push(i);
                                            }
                                            if (current.hour() === FromTime.hour()) {
                                              for (let i = 0; i < FromTime.minute(); i++) {
                                                disabledMinutes.push(i);
                                              }
                                              if (current.minute() === FromTime.minute()) {
                                                for (let i = 0; i < FromTime.second(); i++) {
                                                  disabledSeconds.push(i);
                                                }
                                              }
                                            }
                                          }
                                          if (current.isSame(currentTime, 'day')) {
                                            for (let i = 0; i < currentTime.hour(); i++) {
                                              disabledHours.push(i);
                                            }
                                            if (current.hour() === currentTime.hour()) {
                                              for (let i = 0; i < currentTime.minute(); i++) {
                                                disabledMinutes.push(i);
                                              }
                                              if (current.minute() === currentTime.minute()) {
                                                for (let i = 0; i < currentTime.second(); i++) {
                                                  disabledSeconds.push(i);
                                                }
                                              }
                                            }
                                          }
                                          return {
                                            disabledHours: () => disabledHours,
                                            disabledMinutes: () => disabledMinutes,
                                            disabledSeconds: () => disabledSeconds,
                                          };
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={6}>
                                    <Form.Item
                                      label={translation('Analysis Attachments')}
                                      {...restField}
                                      name={[name, 'AnalysisAttachments']}
                                      key={key}
                                    >
                                      <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                        <Button
                                          onClick={() => existingAnalysisHandleClick('Add New Attachments', Array.isArray(name) ? name.join('-') : name)}
                                          disabled={true}
                                        >
                                          <CloudUploadOutlined /> Upload files
                                        </Button>
                                        <Button onClick={() => existingAnalysisHandleClick('View Attachments', name)}>
                                          <EyeOutlined /> View files
                                        </Button>
                                      </div>
                                      <Upload
                                        multiple={true}
                                        beforeUpload={(file) => {
                                          const isCSV =
                                            file.type === 'image/jpeg' ||
                                            file.name.endsWith('.jpg') ||
                                            file.name.endsWith('.jpeg') ||
                                            file.name.endsWith('.pdf') ||
                                            file.name.endsWith('.png') ||
                                            file.name.endsWith('.ppt') ||
                                            file.name.endsWith('.pptx') ||
                                            file.name.endsWith('.xls') ||
                                            file.name.endsWith('.xlsx') ||
                                            file.name.endsWith('.docx') ||
                                            file.name.endsWith('.doc');
                                          if (!isCSV) {
                                            message.error(`You can not upload ${file.type} files!`);
                                          }
                                          const isLt2M = file.size / 1024 / 1024 < 2;
                                          if (!isLt2M) {
                                            message.error('File must be smaller than 2MB!');
                                          }
                                          return isCSV && isLt2M;
                                        }}
                                        onChange={(info) => analysisFileUpload(info)}
                                        action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=${'fracas'}&Source=${'Analysis'}`}
                                        headers={{
                                          Authorization: Authorization,
                                        }}
                                        showUploadList={false}
                                      >
                                        <Button style={{ display: 'none' }} ref={myRef1} className="uploadFile">
                                          <UploadOutlined /> Upload
                                        </Button>
                                      </Upload>
                                      <Drawer
                                        title="Failure Analysis Uploaded Files"
                                        open={analysisShowusecasedownloadModalExisting}
                                        width={'50%'}
                                        onOk={() => setAnalysisShowusecasedownloadModalExisting(false)}
                                        onClose={() => setAnalysisShowusecasedownloadModalExisting(false)}
                                      >
                                        <StyledTable
                                          size="small"
                                          columns={AnalysisUseCaseColumns}
                                          dataSource={
                                            AnalysisValues &&
                                              AnalysisValues[selectedIndexAnalysis] &&
                                              AnalysisValues[selectedIndexAnalysis].AnalysisAttachments &&
                                              Array.isArray(AnalysisValues[selectedIndexAnalysis].AnalysisAttachments) &&
                                              AnalysisValues[selectedIndexAnalysis].AnalysisAttachments
                                              ? [...AnalysisValues[selectedIndexAnalysis].AnalysisAttachments]
                                              : []
                                          }
                                        />
                                      </Drawer>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={6}>
                                    <Form.Item
                                      label={translation('Failure Cause')}
                                      {...restField}
                                      name={[name, 'FailureCause']}
                                    >
                                      <TextArea
                                        disabled={true}
                                        placeholder="Input Failure Cause"
                                        style={{
                                          width: '100%',
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={6}>
                                    <Form.Item
                                      label={translation('Contributing Factors')}
                                      {...restField}
                                      name={[name, 'ContributingFactors']}
                                    >
                                      <TextArea
                                        disabled={true}
                                        placeholder="Input Contributing Factors"
                                        style={{
                                          width: '100%',
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={6}>
                                    <Form.Item
                                      label={translation('Analysis Description')}
                                      {...restField}
                                      name={[name, 'AnalysisComments']}
                                    >
                                      <TextArea
                                        disabled={true}
                                        placeholder="Input Analysis Description"
                                        style={{
                                          width: '100%',
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Panel>
                            </Collapse>
                          ))}
                        </>
                      )}

                    </Form.List>
                  </Form>

                </Panel>
              </Collapse>

            </div>

            {
              (correctiveStatus && correctiveStatus !== null && correctiveStatus === 'Analysis Completed') ||
                (ExistingCorrective && Array.isArray(ExistingCorrective) && ExistingCorrective.length > 0) ?
                <div
                  style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}
                >
                  <Collapse
                    defaultActiveKey={['1']}
                    style={{ width: '100%' }}
                    expandIcon={({ isActive }) =>
                      isActive ? <UpOutlined /> : <DownOutlined />
                    }
                  >
                    <Panel header="Corrective Actions" key="1">
                      <div
                        style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}
                      >
                        <Form
                          name="dynamic_form_nest_item_CA"
                          autoComplete="off"
                          ref={CARef}
                          form={form4}
                          initialValues={{ Corrective: Corrective }}
                          layout="vertical"
                          className="Answers_Form"
                        >
                          <Form.List name="Corrective">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map(({ key, name, ...restField }, index) => (
                                  <div
                                    key={key}
                                    style={{
                                      display: 'flex',
                                      marginBottom: '1%',
                                      width: '100%',
                                    }}
                                    align="baseline"
                                  >
                                    <Row gutter={[16, 16]} style={{ width: '100%' }}>
                                      <Form.Item name="Id"></Form.Item>

                                      <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                        <Form.Item
                                          label={translation('Change Recommendations')}
                                          {...restField}
                                          name={[name, 'ChangeRecommendations']}
                                          rules={[
                                            {
                                              required: true,
                                              message: 'Please Select Change Recommendations!',
                                            },
                                          ]}
                                        >
                                          <Select
                                            placeholder="Please Select Change Recommendations!"
                                            style={{ width: '100%' }}
                                          >
                                            <Option value={'SECP'}>Software Engineering Change Proposal</Option>
                                            <Option value={'HECP'}>Hardware Engineering Change Proposal</Option>
                                          </Select>
                                        </Form.Item>
                                      </Col>

                                      <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                        <Form.Item
                                          label={translation('Corrective Action Type')}
                                          {...restField}
                                          name={[name, 'CorrectiveActionType']}
                                          rules={[
                                            {
                                              required: true,
                                              message: 'Please Select Corrective Action Type',
                                            },
                                          ]}
                                        >
                                          <Select
                                            placeholder="Please Select Corrective Action Type!"
                                            disabled={selectedKey === 'view'}
                                            style={{ width: '100%' }}
                                          >
                                            <Option value={'Design'}>Design</Option>
                                            <Option value={'ShortTerm'}>Short Term</Option>
                                            <Option value={'LongTerm'}>Long Term</Option>
                                          </Select>
                                        </Form.Item>
                                      </Col>

                                      <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                        <Form.Item
                                          label={translation('Corrective Actions Attachments')}
                                          {...restField}
                                          name={[name, 'CorrectiveActionsAttachments']}
                                          key={key}
                                        >
                                          <div style={{ display: 'flex', gap: '2%', flexWrap: 'wrap', width: '100%' }}>
                                            <Button
                                              onClick={() =>
                                                correctiveHandleClick(
                                                  'Add New Attachments',
                                                  Array.isArray(name) ? name.join('-') : name
                                                )
                                              }
                                              disabled={selectedKey === 'view'}
                                            >
                                              <CloudUploadOutlined /> Upload files
                                            </Button>
                                            <Button onClick={() => correctiveHandleClick('View Attachments', name)}>
                                              <EyeOutlined /> View files
                                            </Button>
                                          </div>

                                          <Upload
                                            multiple={true}
                                            beforeUpload={(file) => {
                                              const isValidType =
                                                file.type === 'image/jpeg' ||
                                                file.name.endsWith('.jpg') ||
                                                file.name.endsWith('.jpeg') ||
                                                file.name.endsWith('.pdf') ||
                                                file.name.endsWith('.png') ||
                                                file.name.endsWith('.ppt') ||
                                                file.name.endsWith('.pptx') ||
                                                file.name.endsWith('.xls') ||
                                                file.name.endsWith('.xlsx') ||
                                                file.name.endsWith('.docx') ||
                                                file.name.endsWith('.doc');
                                              if (!isValidType) {
                                                message.error(`You cannot upload ${file.type} files!`);
                                              }
                                              const isLt2M = file.size / 1024 / 1024 < 2;
                                              if (!isLt2M) {
                                                message.error('File must be smaller than 2MB!');
                                              }
                                              return isValidType && isLt2M;
                                            }}
                                            onChange={(info) => correctiveFileUpload(info, key, selectedIndex)}
                                            action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=CorrectiveActions`}
                                            headers={{
                                              Authorization: Authorization,
                                            }}
                                            showUploadList={false}
                                          >
                                            <Button style={{ display: 'none' }} ref={myRef2} className="uploadFile">
                                              <UploadOutlined /> Upload
                                            </Button>
                                          </Upload>

                                          <Drawer
                                            title="Corrective Actions Uploaded Files"
                                            open={correctiveShowusecasedownloadModal}
                                            width="50%"
                                            onOk={() => setCorrectiveShowusecasedownloadModal(false)}
                                            onClose={() => setCorrectiveShowusecasedownloadModal(false)}
                                          >
                                            <StyledTable
                                              size="small"
                                              columns={CorrectiveActionsUseCaseColumns}
                                              dataSource={
                                                correctiveFormObject &&
                                                  correctiveFormObject.CorrectiveActionsAttachments &&
                                                  correctiveFormObject.CorrectiveActionsAttachments[selectedIndex] &&
                                                  Array.isArray(correctiveFormObject.CorrectiveActionsAttachments[selectedIndex])
                                                  ? [...correctiveFormObject.CorrectiveActionsAttachments[selectedIndex]]
                                                  : []
                                              }
                                            />
                                          </Drawer>
                                        </Form.Item>
                                      </Col>

                                      <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                        <Form.Item
                                          label={translation('Planned Corrective Actions')}
                                          {...restField}
                                          name={[name, 'PlannedCorrectiveActions']}
                                          rules={[
                                            {
                                              required: true,
                                              message: 'Please Input Planned Corrective Actions!',
                                            },
                                          ]}
                                        >
                                          <TextArea
                                            disabled={selectedKey === 'view'}
                                            placeholder="Input Planned Corrective Actions"
                                            style={{ width: '100%' }}
                                          />
                                        </Form.Item>
                                      </Col>

                                      <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                        <Form.Item
                                          label={translation('Implemented Corrective Actions')}
                                          {...restField}
                                          name={[name, 'ImplementedCorrectiveActions']}
                                          rules={[
                                            {
                                              required: true,
                                              message: 'Please Input Implemented Corrective Actions!',
                                            },
                                          ]}
                                        >
                                          <TextArea
                                            disabled={selectedKey === 'view'}
                                            placeholder="Input Implemented Corrective Actions"
                                            style={{ width: '100%' }}
                                          />
                                        </Form.Item>
                                      </Col>

                                      <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                        <Form.Item
                                          label={translation('Verification and Validation field remarks')}
                                          {...restField}
                                          name={[name, 'VerificationAndValidationFieldRemarks']}
                                        >
                                          <TextArea
                                            disabled={selectedKey === 'view'}
                                            placeholder="Input Verification and Validation field remarks"
                                            style={{ width: '100%' }}
                                          />
                                        </Form.Item>
                                      </Col>
                                    </Row>

                                    {Corrective && Corrective[name] && Corrective[name].Id ? null : (
                                      <MinusCircleOutlined onClick={() => remove(name)} />
                                    )}
                                  </div>
                                ))}

                                {(correctiveStatus === 'Analysis Completed') && !(selectedKey === 'view') && (
                                  <Form.Item style={{ marginTop: '20px' }}>
                                    <Button
                                      type="dashed"
                                      style={{ width: '500px' }}
                                      onClick={() => add()}
                                      block
                                      icon={<PlusOutlined />}
                                      disabled={selectedKey === 'view'}
                                    >
                                      Add Corrective Actions
                                    </Button>
                                  </Form.Item>
                                )}
                              </>
                            )}
                          </Form.List>
                        </Form>
                        <Form
                          name="dynamic_form_nest_item_CAE"
                          autoComplete="off"
                          ref={CARef}
                          form={ExistingCorrectiveRef}
                          initialValues={{ ExistingCorrective: ExistingCorrective }}
                          style={{ width: '100%' }}
                          layout="vertical"
                          className="Answers_Form"
                        >
                          <Form.List name="ExistingCorrective">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map(({ key, name, ...restField }, index) => (
                                  <Collapse
                                    defaultActiveKey={['1']}
                                    style={{ width: '100%' }}
                                    expandIcon={({ isActive }) =>
                                      isActive ? <UpOutlined /> : <DownOutlined />
                                    }
                                    key={name}
                                  >
                                    <Panel
                                      header={
                                        <span>
                                          <span style={{ fontWeight: 'bold' }}>{'UserName'}</span> :
                                          <span style={{ margin: '0px 8px' }}>
                                            {ExistingCorrective[name].FirstName},
                                          </span>
                                          <span style={{ fontWeight: 'bold' }}>
                                            {'Department Name'}
                                          </span>{' '}
                                          :
                                          <span style={{ margin: '0px 8px' }}>
                                            {ExistingCorrective[name].Name}
                                          </span>
                                        </span>
                                      }
                                      key="1"
                                    >
                                      <div
                                        key={key}
                                        style={{
                                          display: 'flex',
                                          width: '100%',
                                        }}
                                        align="baseline"
                                      >
                                        <Row gutter={[16, 16]} style={{ width: '100%' }}>
                                          <Form.Item name="Id"></Form.Item>

                                          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                            <Form.Item
                                              label={translation('Change Recommendations')}
                                              {...restField}
                                              name={[name, 'ChangeRecommendations']}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'Please Select Change Recommendations!',
                                                },
                                              ]}
                                            >
                                              <Select
                                                placeholder="Please Select Change Recommendations!"
                                                style={{ width: '100%' }}
                                                disabled={true}
                                              >
                                                <Option value={'SECP'}>
                                                  Software Engineering Change Proposal
                                                </Option>
                                                <Option value={'HECP'}>
                                                  Hardware Engineering Change Proposal
                                                </Option>
                                              </Select>
                                            </Form.Item>
                                          </Col>

                                          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                            <Form.Item
                                              label={translation('Corrective Action Type')}
                                              {...restField}
                                              name={[name, 'CorrectiveActionType']}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'Please Select Corrective Action Type',
                                                },
                                              ]}
                                            >
                                              <Select
                                                placeholder="Please Select Corrective Action Type!"
                                                disabled={true}
                                                style={{ width: '100%' }}
                                              >
                                                <Option value={'Design'}>Design</Option>
                                                <Option value={'ShortTerm'}>Short Term</Option>
                                                <Option value={'LongTerm'}>Long Term</Option>
                                              </Select>
                                            </Form.Item>
                                          </Col>

                                          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                            <Form.Item
                                              label={translation('Corrective Actions Attachments')}
                                              {...restField}
                                              name={[name, 'CorrectiveActionsAttachments']}
                                              key={key}
                                            >
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  gap: '2%',
                                                  flexWrap: 'wrap',
                                                  width: '100%',
                                                }}
                                              >
                                                <Button
                                                  onClick={() =>
                                                    existingCorrectiveHandleClick(
                                                      'Add New Attachments',
                                                      Array.isArray(name) ? name.join('-') : name
                                                    )
                                                  }
                                                  disabled={true}
                                                >
                                                  <CloudUploadOutlined /> Upload files
                                                </Button>
                                                <Button
                                                  onClick={() =>
                                                    existingCorrectiveHandleClick('View Attachments', name)
                                                  }
                                                >
                                                  <EyeOutlined /> View files
                                                </Button>
                                              </div>

                                              <Upload
                                                multiple={true}
                                                beforeUpload={(file) => {
                                                  const isCSV =
                                                    file.type === 'image/jpeg' ||
                                                    file.name.endsWith('.jpg') ||
                                                    file.name.endsWith('.jpeg') ||
                                                    file.name.endsWith('.pdf') ||
                                                    file.name.endsWith('.png') ||
                                                    file.name.endsWith('.ppt') ||
                                                    file.name.endsWith('.pptx') ||
                                                    file.name.endsWith('.xls') ||
                                                    file.name.endsWith('.xlsx') ||
                                                    file.name.endsWith('.docx') ||
                                                    file.name.endsWith('.doc');
                                                  if (!isCSV) {
                                                    message.error(`You can not upload ${file.type} files!`);
                                                  }
                                                  const isLt2M = file.size / 1024 / 1024 < 2;
                                                  if (!isLt2M) {
                                                    message.error('File must be smaller than 2MB!');
                                                  }
                                                  return isCSV && isLt2M;
                                                }}
                                                onChange={(info) => correctiveFileUpload(info, key, selectedIndex)}
                                                action={`${API_FRACAS_MULTIPLE.ReportingSaveFile}?SiteId=${siteId}&Type=fracas&Source=CorrectiveActions`}
                                                headers={{
                                                  Authorization: Authorization,
                                                }}
                                                showUploadList={false}
                                              >
                                                <Button style={{ display: 'none' }} ref={myRef2} className="uploadFile">
                                                  <UploadOutlined /> Upload
                                                </Button>
                                              </Upload>

                                              <Drawer
                                                title="Corrective Actions Uploaded Files"
                                                open={correctiveShowusecasedownloadModalExisting}
                                                width={'50%'}
                                                onOk={() => setCorrectiveShowusecasedownloadModalExisting(false)}
                                                onClose={() => setCorrectiveShowusecasedownloadModalExisting(false)}
                                              >
                                                <StyledTable
                                                  size="small"
                                                  columns={CorrectiveActionsUseCaseColumns}
                                                  dataSource={
                                                    ExistingCorrective &&
                                                      ExistingCorrective[selectedIndexEC] &&
                                                      ExistingCorrective[selectedIndexEC].CorrectiveActionsAttachments &&
                                                      Array.isArray(ExistingCorrective[selectedIndexEC].CorrectiveActionsAttachments)
                                                      ? [...ExistingCorrective[selectedIndexEC].CorrectiveActionsAttachments]
                                                      : []
                                                  }
                                                />
                                              </Drawer>
                                            </Form.Item>
                                          </Col>

                                          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                            <Form.Item
                                              label={translation('Planned Corrective Actions')}
                                              {...restField}
                                              name={[name, 'PlannedCorrectiveActions']}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'Please Input Planned Corrective Actions!',
                                                },
                                              ]}
                                            >
                                              <TextArea
                                                disabled={true}
                                                placeholder="Input Planned Corrective Actions"
                                                style={{
                                                  width: '100%',
                                                }}
                                              />
                                            </Form.Item>
                                          </Col>

                                          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                            <Form.Item
                                              label={translation('Implemented Corrective Actions')}
                                              {...restField}
                                              name={[name, 'ImplementedCorrectiveActions']}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: 'Please Input Implemented Corrective Actions!',
                                                },
                                              ]}
                                            >
                                              <TextArea
                                                disabled={true}
                                                placeholder="Input Implemented Corrective Actions"
                                                style={{
                                                  width: '100%',
                                                }}
                                              />
                                            </Form.Item>
                                          </Col>

                                          <Col xs={24} sm={24} md={12} lg={12} xl={6}>
                                            <Form.Item
                                              label={translation('Verification and Validation field remarks')}
                                              {...restField}
                                              name={[name, 'VerificationAndValidationFieldRemarks']}
                                            >
                                              <TextArea
                                                disabled={true}
                                                placeholder="Input Verification and Validation field remarks"
                                                style={{
                                                  width: '100%',
                                                }}
                                              />
                                            </Form.Item>
                                          </Col>
                                        </Row>

                                        {ExistingCorrective && ExistingCorrective[name] && ExistingCorrective[name].Id ? null : (
                                          <MinusCircleOutlined onClick={() => remove(name)} />
                                        )}
                                      </div>
                                    </Panel>
                                  </Collapse>
                                ))}

                                {/* Add button commented out per your original code */}
                              </>
                            )}
                          </Form.List>
                        </Form>

                      </div>
                    </Panel>
                  </Collapse>
                </div>
                : null}
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingTop: '2%',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >
              {correctiveButton && correctiveButton === true && (
                <Form.Item style={{ marginBottom: 0 }}>
                  <Button type="primary" onClick={onCorrectiveActionClick}>
                    Proceed to Corrective Actions
                  </Button>
                </Form.Item>
              )}
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={(correctiveButton && correctiveButton === true) || selectedKey === 'view'}
                >
                  Submit
                </Button>
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button key="back" onClick={onCancel} disabled={selectedKey === 'view'}>
                  Cancel
                </Button>
              </Form.Item>
            </div>

          </Form>
        </TabPane>
      </Tabs>
      <Modal
        open={treeVisible}
        width={800}
        height={800}
        closable
        title={translation('Equipment')}
        onCancel={() => setTreeVisible(false)}
        footer={[
          <Button key="back" onClick={onModalCancel}>
            Cancel
          </Button>
        ]}
      >
        <HierarchyModal
          checkedArray={checkedValue || null}
          treeData={equipmentList && equipmentList !== undefined && Object.values(equipmentList)}
          Key="Rule"
          handleDropdownChange={hierarchyDropdownChange}
        />
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    themeValue: state.ThemeReducer,
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(AnalysisAndCorrectiveActions);